import { Component, ElementRef, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import { ShareddtaService } from '@app/services/shareddta.service';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthServiceService } from '@app/services/auth-service.service';
import { DialogService } from '@app/services/dialog.service';
import { TicketsService } from '@app/services/tickets.service';
import { ToastService } from '@app/services/toast.service';
import { BreadcrumbService } from '@app/services/breadcrumb.service';

interface Message {

  id: string;
  author: string;
  text: string;
  timestamp: string;
  timeAgo: string;
  isUser: boolean;
  attachments?: MessageAttachment[];
}

interface MessageAttachment {
  id: string;
  name: string;
  size: number;
  type: string;
  url?: string;
  isImage: boolean;
}

interface Ticket {
  id: string;
  subject: string;
  description: string;
  status: 'open' | 'closed';
  category: string;
}
@Component({
  selector: 'app-ticket-details',
  templateUrl: './ticket-details.component.html',
  styleUrl: './ticket-details.component.scss'
})
export class TicketDetailsComponent implements OnInit, AfterViewInit {
  @ViewChild('chatMessages') chatMessagesRef!: ElementRef;
  @ViewChild('fileInput') fileInputRef!: ElementRef;

  // Ticket data
  ticket: any;

  // Messages
  messages: any = [];

  // Attachments
  attachments = [
    {
      id: 'att1',
      name: 'delivery-truck.png',
      size: 49152,
      type: 'image/png',
      url: 'assets/truck.png'
    }
  ];

  // Message input
  messageText: string = '';
  currentStatus: 'open' | 'close' = 'open';
  selectedFiles: File[] = [];
  selectedFilePreviews: { file: File; url?: string; isImage: boolean }[] = [];

  // Character count
  charCount: number = 0;
  maxChars: number = 500;

  constructor(private router: Router, private dialog: MatDialog,
    private authService: AuthServiceService, private toast: ToastService, private ticketService: TicketsService, private route: ActivatedRoute, private formBuilder: FormBuilder, private dialogService: DialogService, private sharedData: ShareddtaService, private breadcrumbService: BreadcrumbService) { }

  ngAfterViewInit(): void {
    this.sharedData.signalPageReady();
  }
  id: any;
  ngOnInit(): void {
    this.id = this.route.snapshot.params['id'];
    this.getTicketDetails();
    this.scrollToBottom();
  }



  ngAfterViewChecked(): void {
    // Auto-scroll might be needed after view updates
  }

  // Toggle Status
  toggleStatus(status: 'open' | 'close'): void {
    this.currentStatus = status;
    if (status === 'close') {
      this.ticket.status = 'closed';
    } else {
      this.ticket.status = 'open';
    }
  }

  // Update Character Count
  updateCharCount(): void {
    this.charCount = this.messageText.length;
  }

  // Get char count class
  getCharCountClass(): string {
    if (this.charCount >= 450) return 'danger';
    if (this.charCount >= 400) return 'warning';
    return '';
  }

  // Open File Selector
  openFileSelector(): void {
    this.fileInputRef.nativeElement.click();
  }

  // Handle File Selection
  onFileSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const filesArray = Array.from(input.files);
      this.selectedFiles = [...this.selectedFiles, ...filesArray];
      this.generateFilePreviews();
    }
  }

  // Generate File Previews
  generateFilePreviews(): void {
    this.selectedFilePreviews = [];

    this.selectedFiles.forEach((file) => {
      const isImage = file.type.startsWith('image/');
      const preview = { file, isImage, url: '' };

      if (isImage) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          preview.url = e.target.result;
        };
        reader.readAsDataURL(file);
      }

      this.selectedFilePreviews.push(preview);
    });
  }

  // Remove File
  removeFile(index: number): void {
    this.selectedFiles.splice(index, 1);
    this.selectedFilePreviews.splice(index, 1);
  }

  // Format File Size
  formatFileSize(bytes: number): string {
    return (bytes / 1024).toFixed(2) + ' KB';
  }

  // Send Message
  sendMessage(): void {
    if (!this.messageText.trim() && this.selectedFiles.length === 0) {
      this.toast.show('error', "Please enter a message");
      return;
    }

    var formdata = new FormData();

    // ✅ Required fields append karo
    formdata.append('ticket_id', this.id); // dynamic ho to this.ticketId use karo
    formdata.append('is_close', this.currentStatus === 'close' ? 'true' : 'false');
    formdata.append('message', this.messageText || '');

    const schema = this.route.snapshot.queryParams['schema'];
    const ticketType = this.route.snapshot.queryParams['ticket_type'];
    if (schema) {
      formdata.append('schema', schema);
    }
    if (ticketType) {
      formdata.append('ticket_type', ticketType);
    }

    // ✅ Multiple files ho sakti hain
    if (this.selectedFiles.length > 0) {
      this.selectedFiles.forEach((file) => {
        formdata.append('chat_image', file);
        // agar backend multiple allow karta hai to 'chat_image[]' bhi ho sakta hai
      });
    }

    this.ticketService.sendChat(formdata).subscribe((data: any) => {
      if (this.authService.resultCodeError(data)) {
        return;
      }

      this.getTicketDetails();
      setTimeout(() => this.scrollToBottom(), 100);

      // UI clear karo success ke baad
      this.messageText = '';
      this.selectedFiles = [];
      this.selectedFilePreviews = [];
      this.charCount = 0;

      if (this.fileInputRef) {
        this.fileInputRef.nativeElement.value = '';
      }

      setTimeout(() => this.scrollToBottom(), 1000);

    }, () => {
      this.toast.show('error', "Unable to Send");
    });
  }

  // Scroll to Bottom
  scrollToBottom(): void {
    try {
      if (this.chatMessagesRef) {
        this.chatMessagesRef.nativeElement.scrollTop =
          this.chatMessagesRef.nativeElement.scrollHeight;
      }
    } catch (err) {
      console.error('Scroll error:', err);
    }
  }

  // View Image
  viewImage(url: string): void {
    // TODO: Implement image viewer/lightbox
    window.open(url, '_blank');
  }

  // Download Attachment
  downloadAttachment(url: string) {
    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = url.split('/').pop() || 'file';
        link.click();
        window.URL.revokeObjectURL(blobUrl);
      });
  }




  // Refresh Ticket
  refreshTicket(): void {
    this.getTicketDetails();
  }

  // Delete Ticket
  // deleteTicket(): void {
  //   if (confirm('Are you sure you want to delete this ticket?')) {
  //     console.log('Deleting ticket');
  //     // TODO: Call API to delete ticket
  //     alert('Ticket deleted. Redirecting to list...');
  //     this.backToList();
  //   }
  // }

  // Back to List
  backToList(): void {
    const basePath = this.router.url.includes('/receiving-admin') ? '/receiving-admin' : '/admin';
    this.router.navigate([`${basePath}/ticket`]);
  }

  // Get category display name
  getCategoryName(): string {
    const names: { [key: string]: string } = {
      'company': 'Company Tickets',
      'driver': 'Driver Tickets',
      'customer': 'Customer Tickets',
      'my': 'My Tickets'
    };
    return names[this.ticket.category] || 'Tickets';
  }
  showBtn: boolean = false;
  currentUserEmail: string = '';
  getTicketDetails() {
    const schema = this.route.snapshot.queryParams['schema'];
    const ticketType = this.route.snapshot.queryParams['ticket_type'];
    this.ticketService.getTicketDetails(this.id, schema, ticketType).subscribe((data: any) => {
      if (this.authService.resultCodeError(data)) {
        return;
      }
      this.ticket = data.results;   // single object
      this.currentStatus = this.ticket.ticket_status;

      const isReceivingSide = this.router.url.includes('/receiving-admin');
      this.breadcrumbService.set([
        { label: 'Dashboard', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6', action: () => this.router.navigate([isReceivingSide ? '/receiving-admin/dashboard' : '/admin/dashboard']) },
        { label: 'Tickets', action: () => this.router.navigate([isReceivingSide ? '/receiving-admin/ticket' : '/admin/ticket']) },
        { label: `Ticket #${this.ticket.id}` }
      ]);

      if (this.currentStatus == 'open') {

        this.showBtn = true;
      }
      if (this.currentStatus == 'close') {
        this.showBtn = false;
      }
      this.attachments = this.ticket?.image_ticket?.map((item: any) => {
        const fileName = item.ticket_image.split('/').pop();

        return {
          id: item.id,
          url: item.ticket_image,
          name: fileName,
          size: 0,
          type: this.getFileType(item.ticket_image)
        };
      }) || [];
      this.currentUserEmail = localStorage.getItem('org_email') || '';
      this.messages = [];
      this.ticket.messages.forEach((msg: any) => {
        this.messages.push({
          id: msg.id.toString(),
          author: msg.sender_name,
          text: msg.message,
          timestamp: msg.sent_at,
          timeAgo: msg.chat_since,
          isUser: msg.sender_email === this.currentUserEmail,
          chat_image: msg.chat_image,
          attachments: msg.chat_image ? [
            {
              id: 'img_' + msg.id,
              name: 'image',
              size: 0,
              type: 'image',
              isImage: true,
              url: msg.chat_image
            }
          ] : []
        });
      });



      // if(this.ticketDetails?.messages.length > 0){
      //   // this.markAsReadAllMessages(this.ticketDetails?.messages);
      // }
      setTimeout(() => this.scrollToBottom(), 100);

    }, () => {
      this.toast.show('error', "Unable to create ticket");
    })
  }
  getFileType(url: string): string {
    const extension = url.split('.').pop()?.toLowerCase();

    if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
      return 'image/jpeg';
    }

    return 'application/octet-stream';
  }
  async deleteTicket(): Promise<void> {
    const confirmed = await this.dialogService.confirm(
      'Delete Row',
      'Are you sure you want to delete this ticket? This action cannot be undone.',
      'Delete',
      'Cancel'
    );

    if (confirmed?.confirmed) {

      this.ticketService.deleteTicket(this.id).subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            return;
          }
          if (data.resultDescription) {
            this.toast.show('success', data.resultDescription);
            this.backToList();;
          }
        },
        (error: any) => {
          this.authService.dataError(error);
        }
      );
    }
  }
}
